
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevRating } from '@ds/components/Rating'

import { trackClick } from '@tracking/events'

import translations from './RatingInfo.translations'

export default {
  components: {
    RevRating,
    RevButtonBase,
  },
  props: {
    ratings: {
      type: Object,
      required: true,
    },
    noLink: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    translations: () => translations,

    averageRate() {
      return this.ratings?.averageRate
    },

    reviewsCount() {
      return this.ratings?.reviewsCount
    },

    shouldDisplayRatings() {
      return this.reviewsCount > 0
    },
  },
  methods: {
    onRatingClick() {
      if (this.noLink) {
        return
      }
      trackClick({
        name: 'go_to_reviews',
        pageType: this.$route.name,
        value: this.ratings,
        zone: 'detail',
      })

      document.getElementById('reviews').scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      })
    },
  },
}
